import React from "react";
import { i18n } from '../../translate/i18n';
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import {
  TableCell,
  Tooltip,
} from "@mui/material";

class TableActionButtonsStatic extends React.Component {

  deleteIcon = index => (
    <IconButton onClick={() => this.props.deleteComponent(index)} size="large">
      <Tooltip title={i18n.t('tooltipMatTableOver.delete')}>
        <DeleteIcon style={styles.colorDefaultIcons} />
      </Tooltip>
    </IconButton>
  );

  editIcon = (index) => (
    <IconButton onClick={() => this.props.editComponent(index)} size="large">
      <Tooltip title={i18n.t('tooltipMatTableOver.edit')}>
        <EditIcon style={styles.colorDefaultIcons} />
      </Tooltip>
    </IconButton>
  );

  render() {
    return (
      <TableCell component="th" scope="row" style={styles.tableCell}>
        {this.editIcon(this.props.objContent._id)}
        {this.deleteIcon(this.props.objContent._id)}
      </TableCell>
    );
  }
}

export const styles = {
  tableCell: {
    width: '160px',
  },
  colorDefaultIcons: {
    color: 'black',
  },
  confirm: {
    color: 'darkgreen',
    fontSize: '25px',
  },
  cancel: {
    color: 'red',
    fontSize: '25px',
  }
}

export default TableActionButtonsStatic;
